import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import router from './router'
import store from './store'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'
// 引入自定义插件 notice弹框
import Notice from './plugin/notice'
// 引入loading插件
import LoadingPlugin from './plugin/loading'

Vue.use(Notice)
Vue.use(LoadingPlugin)
Vue.use(VueAwesomeSwiper)
Vue.use(VueRouter)
// import Video from 'video.js'
// import 'video.js/dist/video-js.css'
// Vue.prototype.$video = Video
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import './assets/css/common.css'
import './assets/css/video.css'
import 'dayjs/locale/zh-cn'
import './assets/css/custom.scss'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    primary: '#0081CC',
    secondary: '#E40077',
    info: '#00AFEC',
    light: '#57C3EA'
  },
  icons: {
    iconfont: 'md'
  }
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
